export const CHOOSE_SYSTEMS_PAGE_TITLE_KEY = 'step_choose_systems_title';

export const CHOOSE_SYSTEMS_PAGE_TITLE = 'System Options';
